
import "parsleyjs";
import "bootstrap-datepicker/js/bootstrap-datepicker";

class Forms {
    forms;
    settings;
    options;

    constructor($selector, options) {
        this.forms = $selector ? $selector : $('.js-form-validate');
        this.options = options ? options : {};
        this.settings = $.extend({ popupInstance: null }, options);
    }
    
    bindEvents() {
        $(this.forms).find('[data-date-picker]').each(function () {
            $(this).datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                startDate: new Date(),
                templates: {
                    leftArrow: '<i class="far fa-angle-left"></i>',
                    rightArrow: '<i class="far fa-angle-right"></i>'
                }
            });
        });
    }

    submitButton() {
        $(document).on('submit', 'form', function () {
            let submitText = $(this).find('[data-submit-text]');
            let submittingText = $(this).find('[data-submitting-text]');
            let btn = submitText.closest('button');
            
            submittingText.removeClass('d-none');
            submitText.addClass('d-none');
            btn.prop('disabled', true);
        });
    }
    
    addValidators() {
        Parsley.addValidator('recaptcha', {
            requirementType: 'integer',
            validate: function (value, requirement, instance) {
                return $(instance.$element).data('parsleyRecaptcha') === 1;
            }
        });
        Parsley.addValidator('dropdown', {
            requirementType: 'integer',
            validate: function (value, requirement, instance) {
                var element = $(instance.$element), fieldName = element.data('fieldName'), fields = $('[name="' + fieldName + '"]').filter(function () {
                    return $.trim(this.value) === ""; // remove the $.trim if whitespace is counted as filled
                });
                return !fields.exists();
            }
        });
        Parsley.addValidator('honeypot', {
            requirementType: 'string',
            validate: function (value, requirement, instance) {
                return value === requirement;
            }
        });

    }
    
    validate() {
        
        if (!(this.forms.length > 0)) {
            return this;
        }
        const settings = this.settings;
        Parsley.on('form:submit', function (ParsleyForm) {
            var formElement = ParsleyForm.$element[0];


            if ($(formElement).is('subForm')) {
                var honeypot = $(formElement).find('#validationfield'), honeypotValue = $.trim(honeypot.val());
                if (honeypotValue.length > 0) {
                    console.log(honeypotValue, 'Honey pot value');
                    return;
                }
                else {
                    honeypot.remove();
                    // updates field names
                    var formFields = $(formElement).find('[data-name]');
                    formFields.each(function (key, field) {
                        field.name = $(field).data('name');
                    });
                }
            }
            if (!$(formElement).data('formCreatesend')) {
                $.ajax({
                    url: formElement.action,
                    dataType: "json",
                    type: 'post',
                    data: $(formElement).serialize(),
                    beforeSend: function(){
                        $(formElement).find('[data-fail], [data-success]').addClass('hide');
                    },
                    error: function (error) {
                        $(formElement).find('[data-fail]').removeClass('hide');
                    },
                    success: function (res) {
                        if (res.status === 200) {
                            $(formElement).find('[data-success]').removeClass('hide');
                            $(formElement).trigger('reset');
                            if (settings.popupInstance) {
                                setTimeout(function(){

                                    settings.popupInstance.close();
                                }, 1500)
                            } else {
                                (function smoothscroll(){
                                    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                                    if (currentScroll > 0) {
                                        window.requestAnimationFrame(smoothscroll);
                                        window.scrollTo (0,currentScroll - (currentScroll/5));
                                    }
                                })()
                            }
                        }
                        else {
                            $(formElement).find('[data-fail]').removeClass('hide');
                        }
                    }
                });
                return false;
            }
        });
        $(this.forms).parsley({
            inputs: Parsley.options.inputs + ', [data-parsley-recaptcha], [data-parsley-honeypot], [data-parsley-dropdown]:visible',
            errorClass: 'has-error'
        });

    }
}

export default Forms;
